import { ICustomerSalesProductPayment } from "@/interfaces/customer-sales-product-payment.interfaces";
import { PlansTableMessages } from "@/messages/customer/plans-table.messages";
import { FilterType, IFilter } from "@/types/filter.types";

export const defaultPageNumber = 1;
export const defaultPageSize = 100;

export const PLANS_TABLE_COLUMNS = (messages: PlansTableMessages) => {
  return [
    messages.productColumn,
    messages.planColumn,
    messages.contractDateColumn,
    messages.endDateColumn,
    messages.renewalDateColumn,
    messages.pricePerEventColumn,
    messages.eventsIncludedMonthlyFeeColumn,
    messages.feePerSalesConversionColumn,
    messages.fixedFeePerSalesConvertionColumn,
    messages.fixedMonthlyFeeColumn,
    messages.statusColumn,
    messages.optionsColumn,
  ];
};

export const determineInitialFilterValues = (
  customerSalesProductId: number
): IFilter<ICustomerSalesProductPayment>[] => {
  const initialFilterValues: IFilter<ICustomerSalesProductPayment>[] = [
    {
      property: "customerSalesProductId",
      value: customerSalesProductId,
      filterType: FilterType.Equals,
    },
  ];

  return initialFilterValues;
};
